'use strict';

angular.module('ionic-material', []);

angular.module('ionic-material').factory('ionicMaterialInk', ionicMaterialInk);

function ionicMaterialInk() {
    return {
        displayEffect: function(arg) {
        }
    };
}
